import React from "react";
import styles from "./LoginV2.module.scss";
import { HeroImage } from "./HeroImage";
import logo from "../../public/logo.png";
import {
  login,
  Reset,
  addConfig,
  addSubmodule,
  addKeywords,
  addAccessibleModulesData,
} from "../../Redux/actions/actionCreator/data.action";
import LanguageSelect from "../LanguageSelection";
import { useTranslation } from "react-i18next";
import config from "../../config";
import { useDispatch } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import { allowedModulesHandler } from "../../configHandler";
import { DotLoader } from "../common/DotLoader";

export const LoginComponentV2 = () => {
  const [userid, setuserid] = React.useState("");
  const [password, setpassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [errr, setErr] = React.useState("");
  const [neterr, setneterr] = React.useState("");
  const [loading, setloading] = React.useState(false);
  const [redirect, setredirect] = React.useState(false);

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handlesubmit = (event) => {
    event.preventDefault();
    let resok = true;
    console.log("logging you in...");
    if (userid === "") {
      console.log("email empty line 22 login");
    } else {
      setloading(true);
      fetch(`${config.devurl}/manager/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({
          username: userid.trimEnd(),
          password: password,
        }),
      })
        .then((res) => {
          resok = res.ok;
          console.log("login ", res);
          return res.json();
        })
        .then((data) => {
          console.log("login data", data);
          console.log("login data labels", data.labels);
          setErr("");
          setneterr("");
          if (resok) {
            if (data.flag === false) {
              var token = data.token;
              dispatch(Reset(token));
              setredirect("reset");
              setuserid("");
              setpassword("");
              setloading(false);
              setErr("");
            } else {
              console.log("if else statement inside login line no-51", data);
              localStorage.setItem("token", JSON.stringify(data.token));
              localStorage.setItem("username", userid);
              localStorage.setItem(
                "professionalLabels",
                JSON.stringify({ modules: data.professionalLabels }),
              );
              localStorage.setItem(
                "adminLabels",
                JSON.stringify({ modules: data.adminLabels }),
              );
              localStorage.setItem("id", data.labels.manager);

              localStorage.setItem("accountType", data.type);
              localStorage.setItem("professionalPhoto", data.professionalPhoto);
              if (data.type === "daycare") {
                const payload = data.adminLabels;
                Object.keys(payload).forEach((key) => {
                  Object.keys(payload[key].subModules).forEach(
                    (ele) =>
                      (payload[key].subModules[ele].accessibility = "Edit"),
                  );
                });
                dispatch(addAccessibleModulesData(payload));
              } else {
                console.log("data.modules", data.labels.modules);
                localStorage.setItem(
                  "payload",
                  JSON.stringify({ modules: data.labels.modules }),
                );
                dispatch(addAccessibleModulesData(data.labels.modules));
              }

              const [modulesData, subModuleData] = allowedModulesHandler(
                data.labels,
              );
              localStorage.setItem(
                "config",
                JSON.stringify({
                  data: [...modulesData],
                  subModule: [...subModuleData],
                  keywords: data.labels.keywordLabels,
                  id: data.labels.manager,
                }),
              );
              console.log("config data", allowedModulesHandler(data.labels));
              dispatch(login(data.token));
              dispatch(addConfig(modulesData));
              dispatch(addSubmodule(subModuleData));
              dispatch(addKeywords(data.labels.keywordLabels));

              setloading(false);
              setErr("");
            }
          } else {
            if (data.error) {
              setErr(data.error);
            } else {
              setErr("userid or password incorrect");
            }

            setloading(false);
          }
        })
        .catch((error) => {
          setErr("");
          setloading(false);
          console.log("login data error", error);
          setneterr(
            "Either Server out of reach or server internal error",
            error,
          );
        });
    }
  };


  if (redirect === "reset") {
    return <Redirect to="/resetpassword" />;
  }

  return (
    <div className={styles["login-container"]}>
      <div className={styles["hero-section"]}>
        <div className={styles.illustration}>
          <HeroImage />
        </div>
      </div>

      <div className={styles["form-section"]}>
        <div style={{ position: "absolute", top: 0, right: 0 }}>
          <LanguageSelect />
        </div>
        <div className={styles["form-container"]}>
          <div className={styles.logo}>
            <img
              src={logo}
              alt="Stepswatch logo"
              className={styles.logoImage}
            />
          </div>

          <h2 className={styles["welcome-title"]}>{t("welcome_back")}</h2>
          <p className={styles.subtitle}>{t("enter_your_credentials")}</p>

          <form onSubmit={handlesubmit}>
            <div className={styles["form-group"]}>
              <label htmlFor="userId">{t("Username")}</label>
              <input
                type="text"
                id="userId"
                placeholder={t("Username")}
                onChange={(e) => setuserid(e.target.value)}
                value={userid}
                required
              />
            </div>

            <div className={styles["form-group"]}>
              <label htmlFor="password">{t("password")}</label>
              <div className={styles["password-input-wrapper"]}>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder={"*********"}
                  value={password}
                  onChange={(e) => setpassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className={styles["password-toggle"]}
                  onClick={togglePasswordVisibility}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {!showPassword ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                      <line x1="1" y1="1" x2="23" y2="23" />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
            {errr ? (
              <p className="alert11" style={{ color: "red" }}>
                {errr}
              </p>
            ) : null}
            {neterr ? <p style={{ color: "red" }}>{neterr}</p> : null}
            <div className={styles["form-footer"]}>
              <Link
                to="/forgetpass/user_id" 
                className={styles["forgot-password"]}
              >
                {t("forgotten_password")}
              </Link>
              <button
                type="submit"
                className={styles["login-button"]}
                disabled={loading}
              >
                {loading ? <DotLoader /> : t("login")}
              </button>
            </div>
          </form>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            width: "100%",
            textAlign: "center",
            fontSize: "14px",
          }}
        >
          {t("tnc")}
          <span role="img" aria-label="lock" style={{ marginRight: "4px" }}>
            🔒
          </span>
          <Link
            to="/privacy"
            style={{
              color: "#555",
              textDecoration: "underline",
            }}
          >
            {t("privacyPolicy")}
          </Link>
          {" | "}
          <Link
            to="/support"
            style={{ color: "#555", textDecoration: "underline" }}
          >
            {t("support")}
          </Link>
        </div>
      </div>
    </div>
  );
};
